import invert from 'lodash/invert';
import { defineMessages } from 'react-intl';

import * as D from './deps';

export const DOMAIN_NAME = 'verification' as const;

export const Actions = Object.freeze({
  GET_DISCOUNT_VERIFICATION_INFO: 'GET_DISCOUNT_VERIFICATION_INFO',
  SUBMIT_DISCOUNT_VERIFICATION: 'SUBMIT_DISCOUNT_VERIFICATION',
  CLEAR_DISCOUNT_VERIFICATION_INFO: 'CLEAR_DISCOUNT_VERIFICATION_INFO',
  DISCOUNT_ORG_SEARCH_AUTOCOMPLETE: 'DISCOUNT_ORG_SEARCH_AUTOCOMPLETE',
  RESET_DISCOUNT_VERIFICATION_ERROR: 'RESET_DISCOUNT_VERIFICATION_ERROR',
  REDIRECT_TO_DISCOUNT_VERIFICATION: 'REDIRECT_TO_DISCOUNT_VERIFICATION',
} as const);

export const ReducerKeys = Object.freeze({
  DISCOUNT_ORG_SEARCH_RESULTS: 'discountOrgSearchResults',
  DISCOUNT_VERIFICATION_ERROR_TYPE: 'discountVerificationErrorType',
  DISCOUNT_VERIFICATION_ERROR_MESSAGE: 'discountVerificationErrorMessage',
  DISCOUNT_VERIFICATION_INFO_IS_LOADED: 'discountVerificationInfoIsLoaded',
  DISCOUNT_VERIFICATION_INFO: 'discountVerificationInfo',
} as const);

export const VerificationTypes = Object.freeze({
  STUDENT: 'student',
  MILITARY: 'military',
} as const);

export const DiscountVerificationInfoKeys = Object.freeze({
  DISCOUNT_TYPE: 'discountType',
  STATUS: 'status',
  DOCUMENT_UPLOAD_URL: 'documentUploadURL',
} as const);

export const VerificationStatus = Object.freeze({
  VERIFIED: 'VERIFIED',
  RE_VERIFIED: 'RE_VERIFIED',
  DOC_REVIEW: 'DOC_REVIEW',
  DENIED_4_YEAR: 'DENIED_4_YEAR',
} as const);

export const mapVerificationTypeToDiscountType = Object.freeze({
  [VerificationTypes.STUDENT]: D.PaymentsConstants.discountTypes.STUDENT,
  [VerificationTypes.MILITARY]: D.PaymentsConstants.discountTypes.MILITARY,
} as const);

export const mapDiscountTypeToVerificationType = invert(mapVerificationTypeToDiscountType);

export const VerificationTypeMessage = Object.freeze({
  [VerificationTypes.STUDENT]: D.PaymentsConstants.Messages.student,
  [VerificationTypes.MILITARY]: D.PaymentsConstants.Messages.military,
} as const);

export const discountTypeToOrgSearchAutocompleteType = Object.freeze({
  [D.PaymentsConstants.discountTypes.STUDENT]: 'UNIVERSITY',
  [D.PaymentsConstants.discountTypes.MILITARY]: D.PaymentsConstants.discountTypes.MILITARY,
} as const);

export const Messages = defineMessages({
  alreadyVerifiedDifferentAccount: {
    id: 'alreadyVerifiedDifferentAccount',
    defaultMessage:
      'It looks like your {discount} status has already been applied to another Pandora account. Go to {PandoraHelpLink} for more details.',
  },
  invalidAgeError: {
    id: 'invalidAgeError',
    defaultMessage: 'You are ineligible for verification because of age.',
  },
  invalidOrgError: {
    id: 'invalidOrgError',
    defaultMessage:
      '{org} not found. Please try again later or contact help if the issue continues.',
  },
  militaryOrg: {
    id: 't.militaryOrg',
    defaultMessage: 'Military branch',
  },
  collegeOrg: {
    id: 't.collegeOrg',
    defaultMessage: 'College',
  },
  congratulationsHeader: {
    id: 't.congratulationsHeader',
    defaultMessage: 'Congrats! Your academic status is confirmed.',
  },
  congratulationsSubHeader: {
    id: 't.congratulationsSubHeader',
    defaultMessage: 'Your Student discount is valid for another year.',
  },
  startListening: {
    id: 't.startListening',
    defaultMessage: 'Start Listening',
  },
});

export const OrganizationTypeMessage = Object.freeze({
  [VerificationTypes.STUDENT]: Messages.collegeOrg,
  [VerificationTypes.MILITARY]: Messages.militaryOrg,
} as const);
